var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bot-spinner" },
    [
      _c(
        "v-overlay",
        { attrs: { absolute: true, value: _vm.value.visible } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", color: _vm.value.color },
          }),
        ],
        1
      ),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/bot/spinner/bot.spinner.vue